import { render, staticRenderFns } from "./GetLink.vue?vue&type=template&id=0e649924&scoped=true&"
import script from "./GetLink.js?vue&type=script&lang=js&"
export * from "./GetLink.js?vue&type=script&lang=js&"
import style0 from "./GetLink.scss?vue&type=style&index=0&id=0e649924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e649924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
